import { jsx as _jsx } from "react/jsx-runtime";
var NewTrash = function NewTrash(_ref) {
  var className = _ref.className,
    _ref$color = _ref.color,
    color = _ref$color === void 0 ? '#181B32' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 32 : _ref$size,
    ignoreColor = _ref.ignoreColor;
  return /*#__PURE__*/_jsx("svg", {
    className: className,
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    children: /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M10 17C10.55 17 11 16.55 11 16V12C11 11.45 10.55 11 10 11C9.45 11 9 11.45 9 12V16C9 16.55 9.45 17 10 17ZM14 17C14.55 17 15 16.55 15 16V12C15 11.45 14.55 11 14 11C13.45 11 13 11.45 13 12V16C13 16.55 13.45 17 14 17ZM18 19C18 19.551 17.552 20 17 20H7C6.448 20 6 19.551 6 19V8.00001H18V19ZM10 4.32801C10 4.17301 10.214 4.00001 10.5 4.00001H13.5C13.786 4.00001 14 4.17301 14 4.32801V6.00001H10V4.32801ZM21 6.00001H20H16V4.32801C16 3.04401 14.879 2.00001 13.5 2.00001H10.5C9.121 2.00001 8 3.04401 8 4.32801V6.00001H4H3C2.45 6.00001 2 6.45001 2 7.00001C2 7.55001 2.45 8.00001 3 8.00001H4V19C4 20.654 5.346 22 7 22H17C18.654 22 20 20.654 20 19V8.00001H21C21.55 8.00001 22 7.55001 22 7.00001C22 6.45001 21.55 6.00001 21 6.00001Z",
      fill: !ignoreColor ? color : undefined
    })
  });
};
export default NewTrash;